module.exports = __webpack_public_path__ + "static/media/user-icon.326d6a84.svg";